export const PAGE_CONFIG = {
  "title": "Benchmark",
  "titleCN": "行业基准",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/benchmark/explore",
  "defaultTab": "explore",
  "showTimeZone": false,
  "tabList": [
    {
      "id": "explore",
      "tabName": "Benchmark",
      "tabNameCN": "Benchmark",
      "isHaveNotification": true,
      "notificationPath": "/benchmark/explore",
      "path": "/benchmark/explore",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "206001",
        "pageName": "benchmarkExplore",
        "extInfo": "benchmarkExplore",
        "pagePath": "/benchmark/explore"
      },
      "filters": [
        {
          "name": "DbdBenchmarkFilter",
          "filterPath": "/benchmark/explore",
          "props": {},
          "componentList": [
            {
              "name": "RadarChartCardTitle",
              "titleEn": "Key Performance Metrics Compare to Benchmark",
              "titleCn": "关键表现指标与行业基准比较",
              "props": {
                "defaultActiveList": [
                  "top10per",
                  "median"
                ],
                "options": [
                  {
                    "nameEn": "Top 10%",
                    "nameCn": "前 10%",
                    "value": "top10per",
                    "style": {
                      "background": "rgba(50, 111, 240, 0.1)",
                      "color": "#326ff0"
                    }
                  },
                  {
                    "nameEn": "Median",
                    "nameCn": "中位数",
                    "value": "median",
                    "style": {
                      "background": "rgba(41, 181, 105, 0.1)",
                      "color": "#29b569"
                    }
                  }
                ]
              },
              "children": [
                {
                  "name": "RadarChartCardService",
                  "props": {
                    "api": "/api/v1/dashboard/pc/benchmark/metrics"
                  },
                  "children": [
                    {
                      "name": "RadarChartCardService",
                      "props": {
                        "api": "/api/v1/dashboard/pc/benchmark/max_metrics",
                        "dataKey": "radarChartMaxData"
                      },
                      "children": [
                        {
                          "name": "RadarChartCard"
                        }
                      ]
                    },
                    {
                      "name": "CompetitorTable",
                      "props": {
                        "style": {
                          "marginTop": "65px"
                        },
                        "activeSort": [
                          "top10per",
                          "median"
                        ]
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};